/**
 * Same format the UTM link builder and the API store (mc2-api NormalizesUtmCampaign):
 * lowercase, whitespace collapsed to underscores, empty → null.
 * e.g. "CM 2026 10 County Wave4" → "cm_2026_10_county_wave4"
 */
export function normalizeUtmCampaign(value) {
	if (value === null || value === undefined || String(value).trim() === '') return null
	return String(value).trim().replace(/\s+/g, '_').toLowerCase()
}
